import FadeLoader from 'react-spinners/FadeLoader';
import React from 'react';

const style = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: '1000',
};

const style1 = {
  position: 'fixed',
  width: '100vw',
  height: '100vh',
  zIndex: '1000',
  marginTop: '-200px',
};

export default function LoadingIcon() {
  const color = '#3f51b5';

  return (
    <div style={style1}>
      <div style={style}>
        <FadeLoader height={50} width={20} margin={50} color={color}></FadeLoader>
      </div>
    </div>
  );
}
